import { useMemo } from 'react';

// === 1. World List ===
// ISO 3166-1 alpha-2 country codes and names (Spanish, fallback to English for some)
const COUNTRY_LIST = [
    { value: "AF", label: "Afganistán" },
    { value: "AL", label: "Albania" },
    { value: "DZ", label: "Argelia" },
    { value: "AD", label: "Andorra" },
    { value: "AO", label: "Angola" },
    { value: "AG", label: "Antigua y Barbuda" },
    { value: "AR", label: "Argentina" },
    { value: "AM", label: "Armenia" },
    { value: "AU", label: "Australia" },
    { value: "AT", label: "Austria" },
    { value: "AZ", label: "Azerbaiyán" },
    { value: "BS", label: "Bahamas" },
    { value: "BH", label: "Baréin" },
    { value: "BD", label: "Bangladés" },
    { value: "BB", label: "Barbados" },
    { value: "BY", label: "Bielorrusia" },
    { value: "BE", label: "Bélgica" },
    { value: "BZ", label: "Belice" },
    { value: "BJ", label: "Benín" },
    { value: "BT", label: "Bután" },
    { value: "BO", label: "Bolivia" },
    { value: "BA", label: "Bosnia y Herzegovina" },
    { value: "BW", label: "Botsuana" },
    { value: "BR", label: "Brasil" },
    { value: "BN", label: "Brunéi" },
    { value: "BG", label: "Bulgaria" },
    { value: "BF", label: "Burkina Faso" },
    { value: "BI", label: "Burundi" },
    { value: "CV", label: "Cabo Verde" },
    { value: "KH", label: "Camboya" },
    { value: "CM", label: "Camerún" },
    { value: "CA", label: "Canadá" },
    { value: "CF", label: "República Centroafricana" },
    { value: "TD", label: "Chad" },
    { value: "CL", label: "Chile" },
    { value: "CN", label: "China" },
    { value: "CO", label: "Colombia" },
    { value: "KM", label: "Comoras" },
    { value: "CG", label: "Congo" },
    { value: "CD", label: "Congo (RDC)" },
    { value: "CR", label: "Costa Rica" },
    { value: "CI", label: "Costa de Marfil" },
    { value: "HR", label: "Croacia" },
    { value: "CU", label: "Cuba" },
    { value: "CY", label: "Chipre" },
    { value: "CZ", label: "Chequia" },
    { value: "DK", label: "Dinamarca" },
    { value: "DJ", label: "Yibuti" },
    { value: "DM", label: "Dominica" },
    { value: "DO", label: "República Dominicana" },
    { value: "EC", label: "Ecuador" },
    { value: "EG", label: "Egipto" },
    { value: "SV", label: "El Salvador" },
    { value: "GQ", label: "Guinea Ecuatorial" },
    { value: "ER", label: "Eritrea" },
    { value: "EE", label: "Estonia" },
    { value: "SZ", label: "Esuatini" },
    { value: "ET", label: "Etiopía" },
    { value: "FJ", label: "Fiyi" },
    { value: "FI", label: "Finlandia" },
    { value: "FR", label: "Francia" },
    { value: "GA", label: "Gabón" },
    { value: "GM", label: "Gambia" },
    { value: "GE", label: "Georgia" },
    { value: "DE", label: "Alemania" },
    { value: "GH", label: "Ghana" },
    { value: "GR", label: "Grecia" },
    { value: "GD", label: "Granada" },
    { value: "GT", label: "Guatemala" },
    { value: "GN", label: "Guinea" },
    { value: "GW", label: "Guinea-Bisáu" },
    { value: "GY", label: "Guyana" },
    { value: "HT", label: "Haití" },
    { value: "HN", label: "Honduras" },
    { value: "HU", label: "Hungría" },
    { value: "IS", label: "Islandia" },
    { value: "IN", label: "India" },
    { value: "ID", label: "Indonesia" },
    { value: "IR", label: "Irán" },
    { value: "IQ", label: "Irak" },
    { value: "IE", label: "Irlanda" },
    { value: "IL", label: "Israel" },
    { value: "IT", label: "Italia" },
    { value: "JM", label: "Jamaica" },
    { value: "JP", label: "Japón" },
    { value: "JO", label: "Jordania" },
    { value: "KZ", label: "Kazajistán" },
    { value: "KE", label: "Kenia" },
    { value: "KI", label: "Kiribati" },
    { value: "KW", label: "Kuwait" },
    { value: "KG", label: "Kirguistán" },
    { value: "LA", label: "Laos" },
    { value: "LV", label: "Letonia" },
    { value: "LB", label: "Líbano" },
    { value: "LS", label: "Lesoto" },
    { value: "LR", label: "Liberia" },
    { value: "LY", label: "Libia" },
    { value: "LI", label: "Liechtenstein" },
    { value: "LT", label: "Lituania" },
    { value: "LU", label: "Luxemburgo" },
    { value: "MG", label: "Madagascar" },
    { value: "MW", label: "Malaui" },
    { value: "MY", label: "Malasia" },
    { value: "MV", label: "Maldivas" },
    { value: "ML", label: "Malí" },
    { value: "MT", label: "Malta" },
    { value: "MH", label: "Islas Marshall" },
    { value: "MR", label: "Mauritania" },
    { value: "MU", label: "Mauricio" },
    { value: "MX", label: "México" },
    { value: "FM", label: "Micronesia" },
    { value: "MD", label: "Moldavia" },
    { value: "MC", label: "Mónaco" },
    { value: "MN", label: "Mongolia" },
    { value: "ME", label: "Montenegro" },
    { value: "MA", label: "Marruecos" },
    { value: "MZ", label: "Mozambique" },
    { value: "MM", label: "Birmania" },
    { value: "NA", label: "Namibia" },
    { value: "NR", label: "Nauru" },
    { value: "NP", label: "Nepal" },
    { value: "NL", label: "Países Bajos" },
    { value: "NZ", label: "Nueva Zelanda" },
    { value: "NI", label: "Nicaragua" },
    { value: "NE", label: "Níger" },
    { value: "NG", label: "Nigeria" },
    { value: "NO", label: "Noruega" },
    { value: "OM", label: "Omán" },
    { value: "PK", label: "Pakistán" },
    { value: "PW", label: "Palaos" },
    { value: "PA", label: "Panamá" },
    { value: "PG", label: "Papúa Nueva Guinea" },
    { value: "PY", label: "Paraguay" },
    { value: "PE", label: "Perú" },
    { value: "PH", label: "Filipinas" },
    { value: "PL", label: "Polonia" },
    { value: "PT", label: "Portugal" },
    { value: "QA", label: "Catar" },
    { value: "RO", label: "Rumanía" },
    { value: "RU", label: "Rusia" },
    { value: "RW", label: "Ruanda" },
    { value: "KN", label: "San Cristóbal y Nieves" },
    { value: "LC", label: "Santa Lucía" },
    { value: "VC", label: "San Vicente y las Granadinas" },
    { value: "WS", label: "Samoa" },
    { value: "SM", label: "San Marino" },
    { value: "ST", label: "Santo Tomé y Príncipe" },
    { value: "SA", label: "Arabia Saudita" },
    { value: "SN", label: "Senegal" },
    { value: "RS", label: "Serbia" },
    { value: "SC", label: "Seychelles" },
    { value: "SL", label: "Sierra Leona" },
    { value: "SG", label: "Singapur" },
    { value: "SK", label: "Eslovaquia" },
    { value: "SI", label: "Eslovenia" },
    { value: "SB", label: "Islas Salomón" },
    { value: "SO", label: "Somalia" },
    { value: "ZA", label: "Sudáfrica" },
    { value: "KR", label: "Corea del Sur" },
    { value: "SS", label: "Sudán del Sur" },
    { value: "ES", label: "España" },
    { value: "LK", label: "Sri Lanka" },
    { value: "SD", label: "Sudán" },
    { value: "SR", label: "Surinam" },
    { value: "SE", label: "Suecia" },
    { value: "CH", label: "Suiza" },
    { value: "SY", label: "Siria" },
    { value: "TW", label: "Taiwán" },
    { value: "TJ", label: "Tayikistán" },
    { value: "TZ", label: "Tanzania" },
    { value: "TH", label: "Tailandia" },
    { value: "TL", label: "Timor Oriental" },
    { value: "TG", label: "Togo" },
    { value: "TO", label: "Tonga" },
    { value: "TT", label: "Trinidad y Tobago" },
    { value: "TN", label: "Túnez" },
    { value: "TR", label: "Turquía" },
    { value: "TM", label: "Turkmenistán" },
    { value: "TV", label: "Tuvalu" },
    { value: "UG", label: "Uganda" },
    { value: "UA", label: "Ucrania" },
    { value: "AE", label: "Emiratos Árabes Unidos" },
    { value: "GB", label: "Reino Unido" },
    { value: "US", label: "Estados Unidos" },
    { value: "UY", label: "Uruguay" },
    { value: "UZ", label: "Uzbekistán" },
    { value: "VU", label: "Vanuatu" },
    { value: "VA", label: "Ciudad del Vaticano" },
    { value: "VE", label: "Venezuela" },
    { value: "VN", label: "Vietnam" },
    { value: "YE", label: "Yemen" },
    { value: "ZM", label: "Zambia" },
    { value: "ZW", label: "Zimbabue" }
];

// === 2. Latin America Subset ===
const LATIN_AMERICA_COUNTRY_LIST = [
    { value: "AR", label: "Argentina" },
    { value: "BZ", label: "Belice" },
    { value: "BO", label: "Bolivia" },
    { value: "BR", label: "Brasil" },
    { value: "CL", label: "Chile" },
    { value: "CO", label: "Colombia" },
    { value: "CR", label: "Costa Rica" },
    { value: "CU", label: "Cuba" },
    { value: "DO", label: "República Dominicana" },
    { value: "EC", label: "Ecuador" },
    { value: "SV", label: "El Salvador" },
    { value: "GT", label: "Guatemala" },
    { value: "GY", label: "Guyana" },
    // { value: "GF", label: "Guayana Francesa" }, // Not in original list, keeping only those from COUNTRY_LIST for consistency
    { value: "HT", label: "Haití" },
    { value: "HN", label: "Honduras" },
    { value: "MX", label: "México" },
    { value: "NI", label: "Nicaragua" },
    { value: "PA", label: "Panamá" },
    { value: "PY", label: "Paraguay" },
    { value: "PE", label: "Perú" },
    { value: "SR", label: "Surinam" },
    { value: "TT", label: "Trinidad y Tobago" },
    { value: "UY", label: "Uruguay" },
    { value: "VE", label: "Venezuela" },
];

// === 3. Exported Hooks ===

/**
 * Hook to get the memoized complete list of all countries.
 * Exported as the default.
 */
export default function useCountryOptions() {
    return useMemo(() => COUNTRY_LIST, []);
}

/**
 * Hook to get the memoized list of Latin American countries.
 * Exported as a named export.
 */
export function useLatinAmericaCountryOptions() {
    return useMemo(() => LATIN_AMERICA_COUNTRY_LIST, []);
}

// === 4. Exported Lists (Optional) ===

/**
 * Export the raw lists as named exports in case you don't need the React hook.
 */
export const AllCountries = COUNTRY_LIST;
export const LatinAmericaCountries = LATIN_AMERICA_COUNTRY_LIST;